import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import { defineComponent as _defineComponent } from 'vue';
import { useGetUserQuery, useUpdateRealUserMutation } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'EditUserDialog',
  props: {
    value: {
      type: Boolean
    }
  },
  emits: ["input"],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var $i18n;
    if (isVue3) {
      $i18n = useI18n();
    } else {
      $i18n = useNuxtApp().$i18n;
    }
    var _useNuxtApp = useNuxtApp(),
      $vuetify = _useNuxtApp.$vuetify;
    var isOpen = computed({
      get: function get() {
        return props.value;
      },
      set: function set(value) {
        return emit('input', value);
      }
    });
    var _useGetUserQuery = useGetUserQuery(),
      userResult = _useGetUserQuery.result;
    var user = computed(function () {
      var _userResult$value;
      return ((_userResult$value = userResult.value) === null || _userResult$value === void 0 ? void 0 : _userResult$value.getUser) || {
        locale: 'en-US',
        email: ''
      };
    });
    var pendingLocaleReload = ref(false);
    var _useUpdateRealUserMut = useUpdateRealUserMutation(),
      updateRealUser = _useUpdateRealUserMut.mutate,
      onDone = _useUpdateRealUserMut.onDone;
    onDone(function () {
      if (pendingLocaleReload.value) {
        window.location.reload();
      }
    });
    var profileFirstName = ref('');
    var profileLastName = ref('');
    var profileEmail = ref('');
    watch(user, function (nextUser) {
      profileFirstName.value = (nextUser === null || nextUser === void 0 ? void 0 : nextUser.firstName) || '';
      profileLastName.value = (nextUser === null || nextUser === void 0 ? void 0 : nextUser.lastName) || '';
      profileEmail.value = (nextUser === null || nextUser === void 0 ? void 0 : nextUser.email) || '';
    }, {
      immediate: true
    });
    var saveProfile = function saveProfile(patch) {
      if (patch.locale !== undefined) {
        pendingLocaleReload.value = true;
      }
      updateRealUser({
        input: patch
      });
    };
    var locale = computed(function () {
      var _$i18n, _$i18n$locales, _$i18n$locales$find;
      var v = user.value.locale || 'en-US';
      var obj = (_$i18n = $i18n) === null || _$i18n === void 0 ? void 0 : (_$i18n$locales = _$i18n.locales) === null || _$i18n$locales === void 0 ? void 0 : (_$i18n$locales$find = _$i18n$locales.find) === null || _$i18n$locales$find === void 0 ? void 0 : _$i18n$locales$find.call(_$i18n$locales, function (l) {
        return l.code === v || l.is === v;
      });
      if (obj) {
        return obj.code;
      }
      return 'en';
    });
    var onLocaleChange = function onLocaleChange(value) {
      $i18n.setLocale(value);
      if ($vuetify !== null && $vuetify !== void 0 && $vuetify.lang) {
        $vuetify.lang.current = value;
      }
      saveProfile({
        locale: value
      });
    };
    return {
      __sfc: true,
      props: props,
      emit: emit,
      $i18n: $i18n,
      $vuetify: $vuetify,
      isOpen: isOpen,
      userResult: userResult,
      user: user,
      pendingLocaleReload: pendingLocaleReload,
      updateRealUser: updateRealUser,
      onDone: onDone,
      profileFirstName: profileFirstName,
      profileLastName: profileLastName,
      profileEmail: profileEmail,
      saveProfile: saveProfile,
      locale: locale,
      onLocaleChange: onLocaleChange
    };
  }
});